import React from 'react';
import PropTypes from 'prop-types';
import FlatButton from 'material-ui/FlatButton';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { ContentCopyIcon } from 'assets/materialIcons/materialIcons';

const CopyToClipboard = (props) => {

    /**
     * This creates a new element to the document body.
     * It will use the textArea and select the value.
     *
     * @param {string} link
     */
    const handleCopyToClipboard = (link) => {
        const {
            setMessage,
            translate,
        } = props;

        if (!link) {
            return;
        }

        // Create an element.
        const el = document.createElement('textarea');

        // Add the link in the element.
        el.value = link;

        // Prevent it from being visible.
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';

        // Append the element to the body.
        document.body.appendChild(el);

        // Select the element.
        el.select();

        // Copy the element.
        document.execCommand('copy');

        // Remove the element.
        document.body.removeChild(el);

        setMessage(translate('resources.bookings.amend.messages.linkCopied'));
    };

    return (
        <FlatButton
            backgroundColor={ theme.palette.envy }
            hoverColor={ theme.palette.chinook }
            icon={ <ContentCopyIcon color={ theme.palette.white } /> }
            onTouchTap={ () => {
                return handleCopyToClipboard(props.link);
            } }
        />
    );
};

CopyToClipboard.propTypes = {
    link: PropTypes.string.isRequired,
    setMessage: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(CopyToClipboard);



// WEBPACK FOOTER //
// ./src/components/transaction/paymentLink/CopyToClipboard.js